module.exports = __webpack_public_path__ + "img/Header.59b90572.png";